export default function (context, {value, name, field}) {
    let data = context.state[name];
    data.setting[field] = value;
}